import React from 'react';
import './App.css';

const Spinner = () => (
    <div className="spinner-overlay">
        <div className="spinner"></div>
    </div>
);

export default Spinner;